import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of, forkJoin } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { CommissionHoldRelease, RetencionAplicada } from 'src/app/model/commission-hold-release.model';
import { CommissionHoldReleaseService } from 'src/app/services/commission-hold-release.service';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { CommissionDetailHoldReleaseComponent } from '../commission-detail-hold-release/commission-detail-hold-release.component';
import { OtherCatalogsService } from 'src/app/services/other-catalogs.service';
import { CatComponentService } from 'src/app/services/cat-component.service';
import { AuthService } from "src/app/services/auth.service";
import { ModalCommissionHoldReleaseBitComponent } from 'src/app/shared/modal-hold-release-bitacore/modal-hold-release-bitacore.component';

@Component({
  selector: 'app-view-hold-release-commission',
  templateUrl: './view-hold-release-commission.component.html',
  styleUrls: ['./view-hold-release-commission.component.css']
})
export class ViewHoldReleaseCommissionComponent implements OnInit {


  statusOptions = [
    { value: 'PPR', label: 'Pendiente por Retener' },
    { value: 'RT', label: 'Retenido' },
    { value: 'PPL', label: 'Pendiente por Liberar' },
    { value: 'LB', label: 'Liberado' }
  ];

  //Variables for Adding Holds flow.
  optionsCat = [];

  public columnsGridBase: string[] = ["Id Crédito", "Tipo Asesor", "Folio Solicitud", "Asesor"
    , "Id Supervisor", "Nombre Gerente", "Región", "Estado", "Sucursal", "Descuento origen", "Producto", "Monto Credito", "Fecha cobro", "Cliente"];

  public columnsGridBaseFin: string[] = ["Id Crédito", "Tipo Asesor", "Folio Solicitud", "Asesor"
    , "Id Supervisor", "Nombre Gerente", "Región", "Estado", "Sucursal", "Descuento origen", "Producto", "Monto Credito", "Monto Comisión", "Fecha cobro", "Cliente"];

  public columnsGridDailyReport: string[] = ["ID ASESOR", "NOMBRE ASESOR", "REGIÓN", "ESTADO", "SUCURSAL", "Tipo Asesor", "Comision por Retener", "Comision Retenida", "Comision Faltante"];

  public columnsDescReport: string[] = ["ID ASESOR", "ZONA", "ESTADO", "SUCURSAL", "COMISIONES", "FECHA APLICADO", "NOMBRE ARCHIVO"];

  public columnsGridBitacora: string[] = ["Tipo", "Figura Retención", "Motivo Descuento", "Comentarios", "% a Descontar",
    "Monto Pendiente", "Monto Aplicado", "Monto Aplicado Total", "Monto Pendiente Liberar", "Id Credito Aplicado", "Estatus", "Fecha Generación", "Usuario Aplicación", "Area"];

  public columnsGridBitacoraFin: string[] = ["Tipo", "Figura Retención", "Motivo Descuento", "Comentarios", "Id Credito Aplicado", "Estatus", "Fecha Generación", "Usuario Aplicación", "Area"];

  public columnsGridHistFin: string[] = ["Tipo", "Credito Motivo", "Id Asesor", "Figura Retención", "Motivo Descuento", "Comentarios", "% a Descontar",
    "Comisión", "Monto Retenido", "Monto Pendiente", "Estatus", "Fecha Generación", "Usuario Aplicación", "Area", "Detalle"];

  public columnsGridHist: string[] = ["Tipo", "Credito Motivo", "Id Asesor", "Figura Retención", "Motivo Descuento", "Comentarios", "Estatus", "Fecha Generación", "Usuario Aplicación", "Area"];

  public columnsGridRetenciones: string[] = ["", "Id Asesor", "Id Crédito", "Monto capital", "Monto comisión", "Monto retenido", "Extra", "Estatus", "Fecha Generación"];

  public viewTable = 0;
  selected = 'retenciones';
  dtOptions: any = {};
  selectedOption: string[] = ['historico'];
  headerDesc: string = 'Historico de cargas';
  errorDocument: boolean = false;
  statusSelected: string = "";

  idTipoMovimiento: number = 1;
  public listCommissionToHold: CommissionHoldRelease[] = [];
  public objCommissionToHold: CommissionHoldRelease;
  idCredito: string = '';
  fechaInicial: string = '';
  fechaFinal: string = '';
  idAsesor: string = '';
  nombreReporte: string = '';
  montoComisionField: boolean = false;
  role: string = '';
  private CHUNK_SIZE = 1000;

  retencionesMap: { [key: number]: RetencionAplicada[] } = {};
  retencionesRaiz: RetencionAplicada[] = [];

  //Variables for Adding Holds flow.
  constructor(private commissionHoldReleaseService: CommissionHoldReleaseService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private catComponentService: CatComponentService,
    private auth: AuthService,
    private otherCatalogsService: OtherCatalogsService) { }

  ngOnInit() {
    console.log("ngOnInit...");
    this.initializeDataTable('normal');
    console.log("User Roles ...", this.auth.getUserRoles());
    this.role = this.auth.getUserRoles()[0];
    this.catComponentService.getElementsForComponent().subscribe((elementGrant) => {
      elementGrant.data.filter(el => el.component === "app-view-hold-release-commission" && this.auth.getUserRoles().includes(el.role))
        .map(el => {
          this.montoComisionField = el.active
          console.log("Botn service: ", this.montoComisionField);
        });
    });
    this.getCommissionByFilters();
  }

  onNavChange(event: any) {
    console.log("Nav change...", event);
    this.resetValues();
    switch (event.nextId) {
      case 1:
        this.selectedOption = ['historico'];
        this.headerDesc = "Historico de cargas";
        this.getCommissionByFilters();
        break;
      case 2:
        this.selectedOption = ['diario'];
        this.headerDesc = "Recuperación diaria";
        break;
      case 3:
        this.selectedOption = ['base'];
        this.headerDesc = "Base";
        break;
      case 4:
        this.selectedOption = ['fuera'];
        this.headerDesc = "Fuera";
        break;
      case 5:
        this.selectedOption = ['descuentos'];
        this.headerDesc = "Descuentos";
        break;
      case 6:
        this.selectedOption = ['retenciones'];
        this.headerDesc = "Retenciones Aplicadas";
        break;
      case 7:
        this.selectedOption = ['consolidado'];
        // this.headerDesc = "Retenciones Aplicadas";
        break;
    }
    console.log("Selected option: ", this.selectedOption);
  }

  private initializeDataTable(option: string): void {
    this.dtOptions = {
      order: [],
      responsive: true,
      columnDefs: [
        { responsivePriority: 1, width: 100, targets: -1 }
      ],
      // select: 'single',
      bLengthChange: true,
      searching: true,
      dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
      buttons: [],
      autoWidth: false,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_ elementos',
        info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        }
      }
    };
    if (option === 'normal') {
      this.dtOptions.buttons.push({
        extend: 'excel',
        text: 'Excel',
        filename: this.getNombreReporte(),  // ← nombre dinámico
        title: ''
      });
    } else if (option === 'personalizado') {
      this.dtOptions.buttons.push({
        text: 'Excel',
        action: () => {
          this.exportToExcel();
        }
      });
    }
  }

  getCommissionByFilters = () => {
    const requestObject = {
      idCredito: this.idCredito != '' ? Number(this.idCredito) : null,
      fechaInicial: this.fechaInicial != '' ? this.fechaInicial : null,
      fechaFinal: this.fechaFinal != '' ? this.fechaFinal : null,
      asesor: this.idAsesor != '' ? this.idAsesor : null,
      estatus: this.statusSelected != '' ? this.statusSelected : null,
      tipoReporte: this.selectedOption[0]
    };
    this.selectedOption.includes('historico') ? requestObject.asesor = this.auth.getUserRoles()[0] : null;
    console.log("Request Object: ", requestObject);

    console.log("Serching...");
    this.viewTable = 2;
    this.commissionHoldReleaseService.getCommissionByFilters(requestObject)
      .pipe(
        tap((resp: any) => {
          console.log("Respuesta...", resp);
          if (resp.codeHttpStatus != 200) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              html: 'Ocurrió un error al consultar la información !.<br> Intenta de nuevo.',
              confirmButtonText: 'Aceptar'
            });
            this.viewTable = 0;
            return;
          }
          if (resp.data != null && Object.keys(resp.data).length > 0) {
            // this.resetValues();
            this.selected = 'bitacora';
            if (requestObject.tipoReporte === 'bitacora') {
              if (this.idCredito.length > 0) {
                this.initializeDataTable('normal');
                this.objCommissionToHold = resp.data[this.idCredito];
                console.log("Resp:", resp.data[this.idCredito]);
                this.listCommissionToHold = resp.data[this.idCredito].requestCommissionsHoldReleaseList;
                console.log("Resp data:", this.listCommissionToHold);
                if (this.listCommissionToHold.length == 0) this.toastr.warning('No se encontraron Retenciones / Liberaciones para el Credito capturado.', 'Sin información');
              }
              this.viewTable = 1;
            } else if (requestObject.tipoReporte === 'diario') {
              this.selected = 'diario';
              this.initializeDataTable('normal');
              this.listCommissionToHold = Object.values(resp.data);
            } else if (requestObject.tipoReporte === 'descuentos') {
              this.selected = 'descuentos';
              this.initializeDataTable('normal');
              this.listCommissionToHold = Object.values(resp.data);
            } else if (requestObject.tipoReporte === 'base' || requestObject.tipoReporte === 'fuera') {
              this.selected = 'base';
              this.initializeDataTable('personalizado');
              requestObject.tipoReporte === 'base' ? this.nombreReporte = 'Reporte_Base' : this.nombreReporte = 'Reporte_fuera_de_Cobro_Cero';
              console.log("Reporte base de Ret / Lib... ", resp.data);
              this.listCommissionToHold = Object.values(resp.data);
            } else if (requestObject.tipoReporte === 'historico') {
              console.log("Reporte historico de Ret / Lib...", resp.data);
              this.selected = 'historico';
              this.initializeDataTable('normal');
              this.listCommissionToHold = Object.values(resp.data);
            } else if (requestObject.tipoReporte === 'retenciones') {
              console.log("Reporte concentrado de Ret / Lib...", resp.data);
              this.selected = 'retenciones';
              this.listCommissionToHold = Object.values(resp.data);
              this.loadRetencionesAplicadas(resp.data);
            } else {
              console.log("Reporte normal de Ret / Lib...", resp.data);
              this.initializeDataTable('normal');
              this.listCommissionToHold = Object.values(resp.data);
            }
            this.viewTable = 1;
          } else {
            this.toastr.warning('No se encontraron resultados con los filtros capturados.');
            this.resetValues();
          }
        }),
        catchError(error => {
          return of(this.toastr.error('Ocurrió un error al obtener la información.'));
        })
      ).subscribe();
  }

  loadRetencionesAplicadas(data: any) {
    // El backend devuelve Map<Long, List> → aplanamos los valores
    const cadenas: RetencionAplicada[][] = Array.isArray(data)
      ? [data] : Object.values(data) as RetencionAplicada[][];

    // Cada valor del mapa ya es una cadena ordenada (último idHistorico primero)
    this.retencionesRaiz = cadenas.map(cadena => {
      const [primero, ...resto] = cadena;
      return {
        ...primero,         // el primer elemento es el más reciente
        expanded: false,
        children: resto     // el resto son los anteriores en orden descendente
      };
    });
    console.log('Raíces:', this.retencionesRaiz.length);
    console.log('Hijos totales:', cadenas.reduce((acc, c) => acc + c.length - 1, 0));
  }

  renderInChunks(data: any[]) {
    this.listCommissionToHold = [];
    let index = 0;

    const interval = setInterval(() => {
      this.listCommissionToHold.push(
        ...data.slice(index, index + this.CHUNK_SIZE)
      );
      index += this.CHUNK_SIZE;

      if (index >= data.length) {
        clearInterval(interval);
      }
    }, 0);
    this.viewTable = 1;
  }

  resetValues = () => {
    this.objCommissionToHold = null;
    this.listCommissionToHold = [];
    this.viewTable = 0;

    this.fechaInicial = '';
    this.fechaFinal = '';
    this.idAsesor = '';
    this.statusSelected = "";
    this.idCredito = '';
  }

  selectFilter(event) {
    console.log("Validating...", event);
    this.selectedOption = event;
    this.viewTable = 2;
    if (!this.selectedOption.includes('idCredito')) this.idCredito = '';
    if (!this.selectedOption.includes('rangoFecha')) {
      this.fechaInicial = '';
      this.fechaFinal = '';
    }
    if (!this.selectedOption.includes('asesor')) this.idAsesor = '';
    if (!this.selectedOption.includes('estatus')) {
      this.statusSelected = "";
    }
    if (!this.selectedOption.includes('retenciones')) this.idAsesor = '';
    if (event[0] === 'historico') {
      this.getCommissionByFilters();
    }
    this.resetValues();
  }

  validateInputs(): boolean {
    let isSomethingInput = true;
    let count = 0;
    // if (this.idCredito.length > 0) count++;
    if (this.fechaInicial.length > 0 && this.fechaFinal.length > 0) count++;
    // if (this.idAsesor.length > 0) count++;
    if (this.statusSelected.length > 0) count++;

    if (this.selectedOption.includes('diario')) {
      count++;
    } else if (this.selectedOption.includes('base')) {
      count++;
    } else if (this.selectedOption.includes('fuera')) {
      count++;
    } else if (this.selectedOption.includes('descuentos')) {
      count++;
    } else if (this.selectedOption.includes('historico')) {
      count++;
    } else if (this.selectedOption.includes('retenciones')) {
      count++;
    }
    if (this.selectedOption.length == count) isSomethingInput = false;
    return isSomethingInput;
  }

  verDetalles = (targetModal) => {
    console.log("Ver detalles...", targetModal);
    let modalRef = this.modalService.open(CommissionDetailHoldReleaseComponent, { size: 'xl', centered: true, backdrop: 'static' });
    modalRef.componentInstance.selectedCommissionHoldRelease = targetModal;
    modalRef.result.then(
      data => console.log("Modal closed with:", data),
      objectModal => {
        console.log("Modal dismissed with:", objectModal);
      }
    );
  }

  validateNumber(event: KeyboardEvent) {
    const char = String.fromCharCode(event.which || event.keyCode);
    if (!/^[0-9]$/.test(char)) {
      event.preventDefault(); // Block non-numeric characters
      this.toastr.warning("El campo solo acepta datos numericos!")
    }
  }

  validatePaste(event: ClipboardEvent) {
    const pasteData = event.clipboardData.getData('text');
    if (!/^[0-9]+$/.test(pasteData)) {
      event.preventDefault(); // Block paste if not numeric
      this.toastr.warning("El campo solo acepta datos numericos!")
    }
  }

  getStatusDescription(type: string, statusCode: string): string {
    if (type === 'status') {
      return this.statusOptions.find(option => option.value === statusCode).label || statusCode;
    } else if (type === 'type') {
      return statusCode == "1" ? "Retención" : "Liberación";
    }
  }

  exportToExcel() {
    const excelData = {
      name: this.nombreReporte,
      data: this.listCommissionToHold,
      columns: [
        // Reporte de Excel
        { property: "iCreditId", header: "IdCredito", order: 1 },
        { property: "Empleado", header: "Tipo Asesor", order: 2 },
        { property: "Folio", header: "Folio Solicitud", order: 3 },
        { property: "Convenio", header: "Dependencia Homologado", order: 4 },
        { property: "vEmployeeId", header: "ID asesor", order: 5 },
        { property: "vNombreEmpleado", header: "Nombre Asesor", order: 6 },
        { property: "idSupervisor", header: "Id Supervisor", order: 7 },
        { property: "supervisor", header: "Nombre Supervisor", order: 8 },
        { property: "idGerente", header: "ID Gerente", order: 9 },
        { property: "gerente", header: "Nombre Gerente", order: 10 },
        { property: "Region", header: "Región", order: 11 },
        { property: "Estado", header: "Estado", order: 12 },
        { property: "sucursal", header: "Sucursal", order: 13 },
        { property: "Linea", header: "Descuento origen", order: 14 },
        { property: "Producto", header: "Producto", order: 15 },
        { property: "MontoCapitalTotal", header: "Monto Credito", order: 16 },
        { property: "MontoComisionTotal", header: "Monto Comision", order: 17 },
        { property: "FechaCobro", header: "Fecha cobro", order: 18 },
        { property: "cliente", header: "Nombre del cliente", order: 19 },
        { property: "executionDate", header: "Fecha Base", order: 20 },
        { property: "motivoDescuento", header: "Motivo Descuento", order: 21 },
        { property: "figuraRetencion", header: "Figura a retener(tercia,asesor,call center)", order: 22 },
        { property: "comentarios", header: "Comentarios", order: 23 },
        { property: "porcentageDescontar", header: "% A descontar", order: 24 }
      ]
    };

    if (!excelData || !excelData.data || excelData.data.length === 0) return;

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws_data: any[][] = [];

    // Ordenar las columnas por "order"
    const orderedColumns = excelData.columns
      .filter((col: any) => col.order !== undefined && col.order !== null && col.order !== 0)
      .sort((a: any, b: any) => a.order - b.order);

    const numCols = orderedColumns.length;
    // Primera fila: nombre del reporte (mergeada en todas las columnas)
    const firstRow = Array(numCols).fill('');
    firstRow[0] = excelData.name;
    ws_data.push(firstRow);
    // Segunda fila: headers
    ws_data.push(orderedColumns.map((c: any) => c.header));

    // Filas de datos
    console.log("DTO para exportar: ", excelData);
    excelData.data.forEach((row: any) => {
      const fila: any[] = [];
      orderedColumns.forEach((col: any) => {
        let data = row[col.property] != null && row[col.property] != undefined ? row[col.property] : "";
        switch (col.property) {
          case 'Empleado':
            const tipoEmpleado = data;
            if (tipoEmpleado == "ASESOR INTERNO") {
              data = "Interno"
            } else if (tipoEmpleado == "ALIADO COMERCIAL") {
              data = "Externo"
            } else if (tipoEmpleado == "ASESOR TRAINEE") {
              data = "Trainee"
            }
            break;
          case 'vNombreEmpleado':
            //Validate if the name contains a comma, if it does, split and get the second part (name) to avoid excel 
            if (data.includes(",")) {
              data = data.split(',')[1].trim();
            } else {
              data = data.trim();
            }
            break;
          case 'FechaCobro':
            const [year, month, day] = data.split("-");
            data = `${day}/${month}/${year}`;
            break;
        }
        fila.push(data);
      });
      ws_data.push(fila);
    });

    // Crear worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(ws_data);

    // Merge para centrar el título
    ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } }];

    // Ajustar ancho de columnas (mínimo 15)
    ws['!cols'] = orderedColumns.map((col: any) => ({ wch: Math.max(col.header.length, 15) }));

    // Agregar hoja al libro
    XLSX.utils.book_append_sheet(wb, ws, this.nombreReporte);

    // Descargar Excel
    XLSX.writeFile(wb, `${excelData.name}.xlsx`);
  }

  openModalHoldDetail(item: any) {
    console.log("Opening Modal", item);
    let modalRef = this.modalService.open(ModalCommissionHoldReleaseBitComponent, { size: 'xl', centered: true, backdrop: 'static' });
    modalRef.componentInstance.idCredit = item.id;
    modalRef.componentInstance.idAreaRole = item.userRoleId;
    modalRef.componentInstance.retencion = item;
    modalRef.result.then(
      data => console.log("Modal closed with:", data),
      objectModal => {

      }
    );
  }

  exportarExcelConsolidado(): void {

    Swal.fire({
      icon: 'warning',
      title: 'Generación de Reporte consolidado',
      html: `Desea generar el reporte consolidado ?.`,
      confirmButtonText: 'Aceptar'
    }).then(result => {
      if (!result.isConfirmed) return; // ← si cancela, no hace nada

      this.viewTable = 2;
      const wb = XLSX.utils.book_new();

      const reportes = [
        { tipo: 'base', nombre: 'Reporte Base' },
        { tipo: 'fuera', nombre: 'Fuera de Base' },
        { tipo: 'diario', nombre: 'Recuperación Diario' },
        { tipo: 'descuentos', nombre: 'Descuentos' },
        { tipo: 'retenciones', nombre: 'Retenciones' }
      ];

      const peticiones = reportes.map(reporte =>
        this.commissionHoldReleaseService.getCommissionByFilters({
          idCredito: null,
          fechaInicial: null,
          fechaFinal: null,
          asesor: null,
          estatus: null,
          tipoReporte: reporte.tipo
        }).pipe(
          map((resp: any) => ({ reporte, data: resp.data })),
          catchError(() => of({ reporte, data: null }))
        )
      );

      forkJoin(peticiones).subscribe({
        next: (resultados: any[]) => {
          // ← verificar qué llegó de cada reporte
          resultados.forEach(({ reporte, data }) => {
            if (!data || Object.keys(data).length === 0) return;

            const ws_data: any[][] = [];

            switch (reporte.tipo) {
              case 'base':
              case 'fuera':
                ws_data.push(['Id Crédito', 'Tipo Asesor', 'Folio Solicitud',
                  'Dependencia Homologado',
                  'ID asesor', 'Nombre Asesor',
                  'Id Supervisor', 'Nombre Supervisor',
                  'Id Gerente', 'Gerente',
                  'Región', 'Estado', 'Sucursal',
                  'Descuento Origen', 'Producto', 'Monto Crédito', 'Monto Comisión',
                  'Fecha Cobro', 'Cliente', 'Fecha base', 'Motivo Descuento',
                  'Figura a retener', 'Comentario', '% a descontar']);
                Object.values(data).forEach((item: any) => {
                  ws_data.push([
                    item.iCreditId, item.Empleado, item.Folio, item.Convenio,
                    item.vEmployeeId, item.vNombreEmpleado, item.idSupervisor, item.supervisor,
                    item.idGerente, item.gerente,
                    item.Region, item.Estado, item.sucursal,
                    item.Linea, item.Producto, item.MontoCapitalTotal, item.MontoComisionTotal,
                    item.FechaCobro, item.cliente, item.executionDate, item.motivoDescuento,
                    item.figuraRetencion, item.comentarios, item.porcentageDescontar
                  ]);
                });
                break;
              case 'diario':
                ws_data.push(['ID Asesor', 'Nombre Asesor', 'Región', 'Estado',
                  'Sucursal', 'Tipo Asesor', 'Comisión por Retener',
                  'Comisión Retenida', 'Comisión Faltante']);
                Object.values(data).forEach((item: any) => {
                  ws_data.push([
                    item.vEmployeeId, item.vNombreEmpleado, item.Region,
                    item.Estado, item.sucursal, item.Empleado,
                    item.comisionPorRetener, item.comisionRetenida,
                    item.comisionFaltante
                  ]);
                });
                break;
              case 'descuentos':
                ws_data.push(['ID Asesor', 'Zona', 'Estado', 'Sucursal',
                  'Comisiones', 'Fecha Aplicado', 'Nombre Archivo']);
                Object.values(data).forEach((item: any) => {
                  ws_data.push([
                    item.idAsesor, item.region, item.estado,
                    item.sucursal, item.montoAplicado,
                    item.fechaAplicado,
                    item.fechaCreacion
                  ]);
                });
                break;
              case 'retenciones':
                ws_data.push(['Id Asesor', 'Id Crédito', 'Monto Capital',
                  'Monto Comisión', 'Monto Retenido', 'Extra',
                  'Estatus', 'Fecha Generación']);
                const lista = Array.isArray(data)
                  ? data
                  : (Object.values(data) as any[]).reduce((acc, val) => acc.concat(val), []);
                lista.forEach((item: any) => {
                  ws_data.push([
                    item.idAsesor, item.idCredit, item.capital,
                    item.comision, item.montoRetenido, item.montoExcedenteExtra,
                    item.estatus, item.fechaCreacionAplicado.split('T')[0]
                  ]);
                });
                break;
            }
            if (ws_data.length <= 1) return; // Solo headers, sin datos

            const ws = XLSX.utils.aoa_to_sheet(ws_data);

            // Bold en headers
            ws_data[0].forEach((_, colIndex) => {
              const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex });
              if (ws[cellAddress]) ws[cellAddress].s = { font: { bold: true } };
            });

            // Ancho de columnas
            ws['!cols'] = ws_data[0].map((h: string) => ({ wch: Math.max(h.length || 10, 15) }));

            XLSX.utils.book_append_sheet(wb, ws, reporte.nombre);
          });

          XLSX.writeFile(wb, `Reporte_Consolidado_${new Date().toISOString().split('T')[0]}.xlsx`);
          this.viewTable = 0;
          Swal.fire({
            icon: 'info',
            title: 'Reporte generado exitosamente',
            html: `Nombre del archivo: <strong>Reporte_Consolidado_${new Date().toISOString().split('T')[0]}.xlsx</strong>`,
            confirmButtonText: 'Aceptar'
          });
        },
        error: () => {
          this.toastr.error('Error al generar el reporte consolidado.');
          this.viewTable = 0;
        }
      });
    });

  }

  getNombreReporte(): string {
    switch (this.selected) {
      case 'diario': return 'Reporte_Diario';
      case 'historico': return 'Reporte_Historico';
      case 'bitacora': return 'Reporte_Bitacora';
      case 'base': return 'Reporte_Base';
      case 'fuera': return 'Reporte_Fuera_Cobro_Cero';
      default: return 'Reporte';
    }
  }
}